import { createContext } from 'react'

export type FormContextType = {
  classes?: FormClassesType
  contentSelected?: string[]
}

export type FormClassesType = {
  root: string
  checkbox: string
  input: string
  select: FormSelectType
  progressBar: string
}

export type FormSelectType = {
  option: (state: { isSelected: boolean; isFocused: boolean }) => string
  control: () => string
  valueContainer: () => string
  menuList: () => string
  input: () => string
}

const FormContext = createContext<FormContextType>({
  classes: {
    root: '',
    checkbox: '',
    input: '',
    select: {
      option: () => '',
      control: () => '',
      valueContainer: () => '',
      menuList: () => '',
      input: () => ''
    },
    progressBar: ''
  },
  contentSelected: []
})

export default FormContext
